/*购买成功
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    goodsActivity: (goods_id) => {//查看购买的链接 活动，参与的活动
        return axios.get('api/api/goods/basic_info/goods_activity/' + goods_id);
    },
    goodsTask: (goods_id) => {//查看购买的链接 作业
        return axios.get('api/api/task/info/' + goods_id);
    },
    statusPromote: (goods_type,goods_id,share_id,pay_price) => {//产品
        return axios.get( 'api/api/status-promote?goods_type=' + goods_type + '&goods_id=' + goods_id + '&share_uid=' + share_id + '&pay_price=' + pay_price);
    },
    buyProducts: (product_type,goods_id) => {// 购买后我的买赠
        return axios.get( 'products/give/buy/products?product_type=' + product_type + '&sub_product_id=' + goods_id);
    },
    giveReceive: (data) => {// 领取买赠
        return axios.post('products/give/receive', data);
    },
    
}